import { render, staticRenderFns } from "./newUser.vue?vue&type=template&id=ec4524e6&"
import script from "./newUser.vue?vue&type=script&lang=ts&"
export * from "./newUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports